import script from "./FooterSec.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterSec.vue?vue&type=script&setup=true&lang=js"

import "./FooterSec.vue?vue&type=style&index=0&id=14460fcc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14460fcc"]])

export default __exports__